import { handleAjaxError } from "../../partials/actions/handleAjaxError";
import { useCreditsResponseEvent } from "../../partials/events/useCreditsResponseEvent";
import { updateCredits } from "../../partials/actions/updateCredits";
import { updateChatSettings, resolveChatSettingOption } from "../../partials/actions/updateChatSettings";

const $ = jQuery;
import { saveVideocallMessages, saveMessagesEnabled, autoRecordEnabled, completeLiveKitAssistantTurn } from "./partials/videocallSaveMessages";
import { handleAudioResponse as _handleAudioResponse } from "./partials/videocallAudio";
import { blobToBase64, applyFadeIn, applyFadeOut, resampleFloat32, base64ToInt16, int16ToFloat32, audioBufferToWav, pcm16ToWav } from "./partials/videocallAudioUtils";
import { handleTokenUsage as _handleTokenUsage, handleAwardXp as _handleAwardXp } from "./partials/videocallCredits";
import { playBufferScheduled as _playBufferScheduled, playBuffer as _playBuffer, stopAudio as _stopAudio } from "./partials/videocallPlayer";
import { monitorSilence as _monitorSilence, monitorSpeech as _monitorSpeech, finishRecordingTurn as _finishRecordingTurn, initMic as _initMic, setupAudioRecording as _setupAudioRecording, startRecording as _startRec, stopRecording as _stopRec } from "./partials/videocallRecording";
import { sendToWebSocket as _sendToWebSocket, closeWebSocket as _closeWebSocket, startWebservice as _startWebservice, handleWebSocketMessage as _handleWsMessage, postToAjax as _postToAjax } from "./partials/videocallWebSocket";
import { initializeAudioLevelMonitoring as _initAudioLevel, getCurrentAudioLevel as _getAudioLevel } from "./partials/videocallAudioLevel";
import { setupBackgroundVideo as _setupBackgroundVideo, startLoadingAnimation as _startLoading, stopLoadingAnimation as _stopLoadingAnimation, hideInfoMessageFn, showInfoMessageFn, showSupportErrorMessage as _showSupportErrorMessage, showError as _showError, selectAndSaveMatchedVoice as _selectMatchedVoice, syncMatchVoiceVisibility as _syncMatchVoiceFn } from "./partials/videocallUI";
import { setupModalEvents as _setupModalEvents, initRecordingBtn as _initRecBtn, showActionBtns as _showBtns, hideActionBtns as _hideBtns, muteRecording as _mute, unMuteRecording as _unMute, handleVideocallClick as _handleClick, handleVisibilityChange as _handleVisibility } from "./partials/videocallModal";
import { stopVideocallCamera } from "./partials/videocallCamera";
import { registerEventListeners } from "./partials/videocallEntry";
import { getVideocallMicrophoneStream, releaseVideocallMicrophoneStream } from "./partials/videocallMicrophone";
import { createVideocallDiagnostics } from "./partials/videocallDiagnostics";
import { createVideocallExperience } from "./partials/videocallExperience";
import { createVideocallDebugLogger } from "./partials/videocallDebug";
import { createLiveCallInactivityController } from "./partials/videocallInactivity";
import { muteVideocall as _muteVideocall, showInactiveConversationControl as _showInactiveConversationControl, syncConnectedMuteState as _syncConnectedMuteState, unmuteVideocall as _unmuteVideocall } from "./partials/videocallActions";
import { cancelScheduledVoiceTransportRestart as _cancelScheduledVoiceTransportRestart, changeVideocallVoice as _changeVideocallVoice, interruptVoiceTransport as _interruptVoiceTransport, restartVoiceTransport as _restartVoiceTransport, scheduleVoiceTransportRestart as _scheduleVoiceTransportRestart } from "./partials/videocallVoice";
import {
    acceptWebRTCAnswer as _acceptWebRTCAnswer,
    createWebRTCState,
    interruptWebRTCAssistant,
    setWebRTCMicrophoneMuted,
    startWebRTCLiveCall,
    stopWebRTCLiveCall,
    supportsWebRTCLiveCall,
} from "./partials/videocallWebRTC";
import {
    connectLiveKitSession as _connectLiveKitSession,
    createLiveKitState,
    interruptLiveKitAssistant,
    requestLiveKitSession,
    setLiveKitMuted,
    stopLiveKitCall,
    supportsLiveKitVoice,
} from "./partials/videocallLiveKit";
const currentTranscription = { val: '' };
const VIDEOCALL_CLIENT_BUILD = '!!! PROVIDER SPEECH AUTHORITY 1.0.22-RSYNC-DIAG.24 !!!';

function getVideocallScriptDetails() {
    const script = document.getElementById('growtype-chat-js') ||
        Array.from(document.scripts || []).find((item) => String(item.src || '').includes('/growtype-chat/public/scripts/growtype-chat.js'));
    const src = script ? String(script.src || '') : '';
    let assetVersion = '';
    try {
        assetVersion = src ? new URL(src, window.location.href).searchParams.get('asset-version') || '' : '';
    } catch (error) {}
    return { src: src, assetVersion: assetVersion };
}

const videocallDebug = createVideocallDebugLogger({ build: VIDEOCALL_CLIENT_BUILD });
let webRTCDisabledForPage = false;
let liveKitDisabledForPage = false;

function debugLog(...args) {
    videocallDebug.log(...args);
}

function supportsBrowserSpeechTransport() {
    return !!(
        navigator.mediaDevices &&
        typeof navigator.mediaDevices.getUserMedia === 'function' &&
        (window.AudioContext || window.webkitAudioContext)
    );
}

function liveKitTransportEnabled() {
    const transport = window.growtype_chat_ajax && window.growtype_chat_ajax.videocall_transport;
    return !liveKitDisabledForPage && transport === 'livekit' && supportsLiveKitVoice();
}

function selectedLiveKitProvider() {
    const provider = window.growtype_chat_ajax && window.growtype_chat_ajax.videocall_provider;
    return provider === 'openai' ? 'openai' : 'grok';
}

function webRTCTransportEnabled() {
    const setting = window.growtype_chat_ajax && window.growtype_chat_ajax.videocall_webrtc_enabled !== undefined
        ? window.growtype_chat_ajax.videocall_webrtc_enabled
        : false;
    return !webRTCDisabledForPage && setting !== false && setting !== 0 && setting !== '0' && supportsWebRTCLiveCall();
}

function isAppleMobileDevice() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

function videocall() {
    // Prevent multiple initializations
    if (window.growtypeVideocallInitialized) {
        return;
    }
    window.growtypeVideocallInitialized = true;

    let ajaxRequest;
    let timeoutId;
    let currentAudio;
    const socket = { val: null };
    let isRecording = false;
    let isModalOpen = false;
    let isAudioPlaying = false;
    let infoTextContainer;
    let dotsInterval;
    let reconnectAttempts = 0;
    const maxReconnectAttempts = 3;
    let conversationStopped = false;
    let currentBufferSource = null;
    let scheduledSources = []; // Track all scheduled sources
    const removeDebugLifecycleListeners = videocallDebug.observeBrowserLifecycle(function() {
        return {
            visibilityState: document.visibilityState,
            online: navigator.onLine,
            modalOpen: isModalOpen,
            socketState: socket.val ? socket.val.readyState : null,
            recording: isRecording,
            audioPlaying: isAudioPlaying,
            queuedAudioSources: scheduledSources.length,
        };
    });
    let isMuted = false;
    let audioRecorder
    let sendAudioDebounce = null;
    let userSaidSomethingCounter = 0;
    let btnInitRecordingWasTriggeredOnce = false;
    let sessionStarted = false; // Flag to track if backend session is ready
    let callEverStarted = false;
    let sessionStartInProgress = false; // Prevent multiple start attempts
    let aiResponseStarted = false;
    let openingResponsePending = false;
    let btnRecordTriggered = false;
    const webRTCState = createWebRTCState();
    const liveKitState = createLiveKitState();
    let webRTCFallbackReady = false;
    let webRTCSession = false;
    let liveKitSession = false;
    let legacyResponseCompleted = false;
    let legacyAutoResumePending = false;
    let legacyAutoResumeTimeout = null;
    let discardCurrentRecording = false;
    let assistantAudioGuardUntil = 0;
    let audioLevelInitializationPromise = null;
    const voiceRestartState = { timeout: null };
    let voiceChangeInProgress = false;
    let voiceChangeUnlockTimeout = null;
    const liveCallInactivity = createLiveCallInactivityController({
        onTimeout: function() {
            if (!liveKitSession || isMuted || !sessionStarted) return;
            debugLog('Live Call muted after 40 seconds without user speech');
            muteRecording();
            showInfoMessage('Muted after 40 seconds without speech.');
        },
    });

    function assistantAudioActive() {
        return isAudioPlaying || scheduledSources.length > 0 || Date.now() < assistantAudioGuardUntil;
    }

    function setSessionStarted(value) {
        sessionStarted = Boolean(value);
        if (sessionStarted) callEverStarted = true;
        if (!sessionStarted) openingResponsePending = false;
    }

    function setConversationActive(value) {
        voiceExperience.setConversationActive(value);
    }

    let startRecordingBtnText = 'Start Conversation';
    let processingRecordingBtnText = 'Processing...';
    let stopRecordingBtnText = 'Stop Conversation';
    let continueRecordingBtnText = 'Continue Conversation';

    let sendDebounceTimeout;
    let diagnostics = null;
    const SEND_DEBOUNCE_DELAY = 1500;
    const wsSendCtx = {
        get socket() { return socket.val; },
        get liveCallAccessToken() { return liveCallAccessToken; },
        debugLog: debugLog,
        get _debounceTimeout() { return sendDebounceTimeout; },
        set _debounceTimeout(v) { sendDebounceTimeout = v; },
        sendDebounceDelay: SEND_DEBOUNCE_DELAY,
        supportsLiveSpeech: supportsBrowserSpeechTransport,
        get recordingWasTriggered() { return btnInitRecordingWasTriggeredOnce; },
        get assistantAudioActive() { return assistantAudioActive(); },
        onMessageSent: function(data, metadata) { if (diagnostics) diagnostics.onMessageSent(data, metadata); },
        onSendFailed: function(data, reason) { if (diagnostics) diagnostics.onSendFailed(data, reason); },
    };

    let aiFinishedSpeakingDebounceTimeout;
    const AI_FINISHED_SPEAKING_DEBOUNCE_DELAY = 2000;

    // Audio-level state used only by the last-resort MediaRecorder fallback.
    let analyser;
    let microphone;
    let dataArray;
    let microphoneStream;
    let audioContext = null;

    let chatForm;
    let sessionToken;
    let sessionDomain = '';
    let liveCallAccessToken = '';
    let liveCallReservationId = '';

    let canInterrupt = true;

    diagnostics = createVideocallDiagnostics({
        debugLog: debugLog,
        getState: function() {
            return {
                online: navigator.onLine,
                visibilityState: document.visibilityState,
                modalOpen: isModalOpen,
                socketState: socket.val ? socket.val.readyState : null,
                sessionStarted: sessionStarted,
                sessionStartInProgress: sessionStartInProgress,
                transport: liveKitSession ? 'livekit' : (webRTCSession ? 'webrtc' : (webRTCFallbackReady ? 'media-recorder' : 'pending')),
                recording: isRecording,
                recorderState: audioRecorder ? audioRecorder.state : null,
                muted: isMuted,
                audioPlaying: isAudioPlaying,
                queuedAudioSources: scheduledSources.length,
                audioContextState: audioContext ? audioContext.state : null,
                conversationStopped: conversationStopped,
            };
        },
        onSlowResponse: function() {
            if (isModalOpen && !isAudioPlaying) showInfoMessage('Still thinking…');
        },
        onStalledResponse: function() {
            if (isModalOpen && !isAudioPlaying) showInfoMessage('Response is taking longer than expected…');
        },
    });

    const handleBrowserOnline = function() {
        diagnostics.log('browser returned online');
        if (isModalOpen && !conversationStopped && !liveKitState.active) {
            setVoiceExperienceState('reconnecting', 'Connection restored. Rejoining…');
            startWebservice();
        }
    };
    const handleBrowserOffline = function() {
        diagnostics.log('browser went offline');
        if (isModalOpen) setVoiceExperienceState('reconnecting', 'You are offline. Waiting for connection…');
    };
    window.addEventListener('online', handleBrowserOnline);
    window.addEventListener('offline', handleBrowserOffline);

    // Audio levels are retained only for the last-resort MediaRecorder turn
    // boundary fallback. Provider VAD decides all streaming interruptions.
    const audioLevelCtx = {
        get analyser() { return analyser; }, set analyser(v) { analyser = v; },
        get microphone() { return microphone; }, set microphone(v) { microphone = v; },
        get dataArray() { return dataArray; }, set dataArray(v) { dataArray = v; },
        get microphoneStream() { return microphoneStream; }, set microphoneStream(v) { microphoneStream = v; },
        get audioContext() { return audioContext; }, set audioContext(v) { audioContext = v; },
        debugLog: debugLog,
        stopAudio: function() { _stopAudio(playerState, null, debugLog); },
    };   // Prevent rapid interruptions

    let silenceTimer = null;
    const SILENCE_DELAY = 1100;
    // These are only used by the legacy MediaRecorder fallback. Keep them
    // intentionally sensitive so a quiet phone speaker is not forced to shout.
    const SILENCE_THRESHOLD_FOR_RECORDING = 0.035;
    const USER_SPEECH_THRESHOLD_FOR_RECORDING = 0.08;

    const silenceCtx = {
        get audioRecorder() { return audioRecorder; },
        getCurrentAudioLevel: function() { return _getAudioLevel(audioLevelCtx); },
        silenceThreshold: SILENCE_THRESHOLD_FOR_RECORDING,
        speechThreshold: USER_SPEECH_THRESHOLD_FOR_RECORDING,
        silenceDelay: SILENCE_DELAY,
        get recordingWasTriggered() { return btnInitRecordingWasTriggeredOnce; },
        get assistantAudioActive() { return assistantAudioActive(); },
        get userSaidSomethingCounter() { return userSaidSomethingCounter; },
        set userSaidSomethingCounter(v) { userSaidSomethingCounter = v; },
        debugLog: debugLog,
        onSilenceTimeout: function() {
            if (assistantAudioActive()) {
                debugLog('Automatic turn completion blocked while assistant audio is active', {
                    isAudioPlaying: isAudioPlaying,
                    queuedAudioSources: scheduledSources.length,
                });
                userSaidSomethingCounter = 0;
                return;
            }
            debugLog('Silence detected after user speech; finishing turn without clicking the conversation button');
            recordingCtx.finishUtterance();
        },
        get _silenceTimer() { return silenceTimer; },
        set _silenceTimer(v) { silenceTimer = v; },
    };

    const AudioContextClass = window.AudioContext || window.webkitAudioContext || null;
    if (!AudioContextClass) {
        debugLog("Web Audio is unavailable; video-call audio initialization skipped.");
        return;
    }
    const supportsMediaDevices = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);

    debugLog("Videocall initialized", {
        clientBuild: VIDEOCALL_CLIENT_BUILD,
        script: getVideocallScriptDetails(),
        userAgent: navigator.userAgent,
        visibilityState: document.visibilityState,
        hasAudioContext: !!AudioContextClass,
        supportsMediaDevices: supportsMediaDevices,
        supportsMediaRecorder: typeof window.MediaRecorder !== 'undefined',
        supportsAudioWorklet: !!(AudioContextClass && AudioContextClass.prototype && 'audioWorklet' in AudioContextClass.prototype),
        speechAuthority: 'provider-websocket-vad',
    });

    initRecordingBtn();

    // Setup background video with error handling
    function setupBackgroundVideo(modal) {
        _setupBackgroundVideo(modal);
    }

    // Setup loading animation
    function startLoadingAnimation(modal) {
         setVoiceExperienceState('connecting');
         _startLoading(modal, infoTextContainer, { get interval() { return dotsInterval; }, set interval(v) { dotsInterval = v; } }, () => isModalOpen);
    }

    function stopLoadingAnimation() {
        _stopLoadingAnimation(infoTextContainer, { get interval() { return dotsInterval; }, set interval(v) { dotsInterval = v; } }, hideInfoMessage, debugLog);
    }

    function hideInfoMessage() {
        hideInfoMessageFn(infoTextContainer);
    }

    function showInfoMessage(text) {
        showInfoMessageFn(infoTextContainer, text);
    }

    const voiceExperience = createVideocallExperience({
        debugLog: debugLog,
        showCaption: showInfoMessage,
        getTransport: function() {
            return liveKitSession ? 'livekit' : (webRTCSession ? 'webrtc' : (webRTCFallbackReady ? 'media-recorder' : 'pending'));
        },
    });

    function setVoiceExperienceState(stateName, caption) {
        voiceExperience.setState(stateName, caption);
    }

    function setWebRTCVisualState(stateName) {
        setVoiceExperienceState(stateName);
    }

    function activateLiveKitFallback(error) {
        debugLog('LiveKit fallback activation started', {
            reason: error && error.message ? error.message : 'LiveKit unavailable',
            active: liveKitState.active,
            connecting: liveKitState.connecting,
        });
        stopLiveKitCall(liveKitState);
        liveKitDisabledForPage = true;
        liveKitSession = false;
        if (webRTCTransportEnabled()) return startWebRTC();
        return activateWebRTCFallback(error);
    }

    function startLiveKit() {
        liveKitSession = true;
        webRTCSession = false;
        webRTCFallbackReady = false;
        openingResponsePending = true;
        return requestLiveKitSession(liveKitState, {
            debugLog: debugLog,
            liveAvatarEnabled: $('#growtypeChatVideoCallModal input[name="growtype_chat_live_avatar_enabled"]').is(':checked'),
            onConnecting: function() {
                setVoiceExperienceState('connecting', 'Connecting securely…');
                hideActionBtns();
            },
            sendSessionRequest: function() {
                _sendToWebSocket({
                    type: 'livekit_session',
                    session_token: sessionToken,
                    bot_profile: window.growtype_chat[chatForm.attr('id')]['bot_profile'],
                    voice: getSelectedVideocallVoice(),
                    service: selectedLiveKitProvider(),
                    domain: sessionDomain,
                }, wsSendCtx);
            },
            onFallback: activateLiveKitFallback,
        });
    }

    function connectLiveKit(credentials) {
        return _connectLiveKitSession(liveKitState, credentials, {
            debugLog: debugLog,
            onConnected: function(provider) {
                setVoiceChangeInProgress(false);
                setSessionStarted(true);
                sessionStartInProgress = false;
                isRecording = true;
                $('#growtypeChatVideoCallModal').addClass('is-recording is-livekit');
                stopLoadingAnimation();
                hideActionBtns();
                _syncConnectedMuteState({
                    isMuted: function() { return isMuted; },
                    isTransportMuted: function() { return liveKitState.muted; },
                    setMuted: function(value) { isMuted = value; },
                    setConversationActive: setConversationActive,
                    setMutedControl: function(value) { voiceExperience.setMutedControl(value); },
                    renderConnectedState: function(muted) {
                        if (muted) {
                            setVoiceExperienceState('muted');
                            showInfoMessage('Muted');
                        } else {
                            setVoiceExperienceState('listening', 'Listening… Speak naturally.');
                        }
                    },
                });
                debugLog('LiveKit room connected', { provider: provider });
                if (!isMuted) liveCallInactivity.start();
            },
            onAgentConnected: function(provider) {
                debugLog('LiveKit voice agent joined', { provider: provider });
            },
            onAvatarReady: function() {
                debugLog('Live Avatar video is ready');
                $('#growtypeChatVideoCallModal').addClass('has-live-avatar');
            },
            onAvatarUnavailable: function(message) {
                const modal = $('#growtypeChatVideoCallModal');
                modal.removeClass('has-live-avatar');
                modal.find('input[name="growtype_chat_live_avatar_enabled"]')
                    .prop('checked', false)
                    .prop('disabled', true)
                    .attr('aria-disabled', 'true');
                const errorMessage = message || 'Real-time avatar could not start. Continuing with voice only.';
                let notice = modal.find('.modal-videocall-avatar-runtime-error');
                if (!notice.length) {
                    notice = $('<p class="modal-videocall-avatar-runtime-error" role="alert"></p>');
                    modal.find('.modal-videocall-avatar-setting .label-wrapper').append(notice);
                }
                notice.text(errorMessage);
                showInfoMessage(errorMessage);
            },
            onAgentState: function(stateName) {
                if (isMuted) {
                    isAudioPlaying = false;
                    setVoiceExperienceState('muted');
                    return;
                }
                if (stateName === 'speaking') {
                    isAudioPlaying = true;
                    liveCallInactivity.pause();
                    setVoiceExperienceState('speaking');
                } else if (stateName === 'thinking') {
                    isAudioPlaying = false;
                    liveCallInactivity.pause();
                    setVoiceExperienceState('thinking', 'Thinking…');
                } else if (stateName === 'listening' || stateName === 'idle') {
                    isAudioPlaying = false;
                    liveCallInactivity.start();
                    setVoiceExperienceState('listening', 'Listening… Speak naturally.');
                }
            },
            onUserTranscript: function(transcript, final) {
                liveCallInactivity.noteSpeech();
                window.__userTranscript = transcript;
                currentTranscription.val = transcript;
                showInfoMessage(`You: "${transcript}"`);
                if (final) debugLog('LiveKit final user transcription received', { contentLength: transcript.length });
            },
            onAssistantTranscript: function(transcript, final) {
                window.__aiResponseTranscript = transcript;
                if (!openingResponsePending && infoTextContainer) infoTextContainer.text(transcript);
                const wasOpeningResponse = openingResponsePending;
                completeLiveKitAssistantTurn({
                    final: final,
                    openingResponsePending: wasOpeningResponse,
                    onFinal: function() {
                        debugLog('LiveKit final assistant transcription received', { contentLength: transcript.length });
                        openingResponsePending = false;
                        currentTranscription.val = '';
                    },
                    clearOpeningTranscripts: function() {
                        window.__userTranscript = '';
                        window.__aiResponseTranscript = '';
                        debugLog('Opening LiveKit response completed as audio-only; skipping chat persistence');
                    },
                    saveMessages: function() {
                        saveVideocallMessages(chatForm, sessionToken, debugLog);
                    },
                });
            },
            onAudioPlaybackBlocked: function() {
                showInfoMessage('Tap the screen once to enable call audio.');
            },
            onReconnecting: function() {
                setVoiceExperienceState('reconnecting', 'Connection interrupted. Rejoining…');
            },
            onReconnected: function() {
                setVoiceExperienceState('listening', 'Reconnected — listening…');
            },
            onDisconnected: function(_reason, wasActive) {
                if (wasActive && isModalOpen && !conversationStopped) {
                    liveKitSession = false;
                    setSessionStarted(false);
                    sessionStartInProgress = false;
                    isRecording = false;
                    $('#growtypeChatVideoCallModal').removeClass('is-recording is-livekit');
                    setVoiceExperienceState('error', 'Call disconnected. Tap Continue Conversation to reconnect.');
                    showActionBtns();
                }
            },
            onFallback: activateLiveKitFallback,
        });
    }

    function handleLiveKitError(message) {
        activateLiveKitFallback(new Error(message));
    }

    function activateWebRTCFallback(error) {
        const shouldResumeAfterSetup = btnInitRecordingWasTriggeredOnce && isModalOpen && !isMuted && !conversationStopped;
        debugLog('WebRTC fallback activation started', {
            reason: error && error.message ? error.message : 'WebRTC unavailable',
            shouldResumeAfterSetup: shouldResumeAfterSetup,
            recordingWasTriggered: btnInitRecordingWasTriggeredOnce,
            isModalOpen: isModalOpen,
            isMuted: isMuted,
            conversationStopped: conversationStopped,
            sessionStarted: sessionStarted,
            isRecording: isRecording,
            webRTCState: {
                connecting: webRTCState.connecting,
                active: webRTCState.active,
                fallbackStarted: webRTCState.fallbackStarted,
                dataChannelState: webRTCState.dataChannel ? webRTCState.dataChannel.readyState : null,
            },
        });
        setVoiceExperienceState('connecting', 'Preparing the best audio mode for this device…');
        webRTCSession = false;
        if (webRTCFallbackReady) {
            debugLog('WebRTC fallback activation skipped; fallback is already ready');
            return;
        }
        webRTCFallbackReady = true;
        sessionStartInProgress = false;
        isRecording = false;
        $('#growtypeChatVideoCallModal').removeClass('is-recording is-webrtc');
        return Promise.resolve(setupRecording()).then(function(setupSucceeded) {
            stopLoadingAnimation();
            showActionBtns();
            debugLog('Classic live-call fallback setup completed', {
                setupSucceeded: setupSucceeded,
                shouldResumeAfterSetup: shouldResumeAfterSetup,
                recorderState: audioRecorder ? audioRecorder.state : null,
                sessionStarted: sessionStarted,
            });

            if (setupSucceeded !== false && shouldResumeAfterSetup && isModalOpen && !isMuted && !conversationStopped) {
                debugLog('Automatically starting MediaRecorder after WebRTC fallback');
                startRecording();
                return;
            }

            showInfoMessage('Tap Start, then speak normally.');
            setVoiceExperienceState('idle');
            debugLog('Classic live-call fallback is ready for manual start', {
                reason: error && error.message ? error.message : 'WebRTC unavailable',
            });
        }).catch(function(setupError) {
            console.error('[growtype-chat][videocall] Classic fallback setup failed', setupError);
            setVoiceExperienceState('error', 'Tap Start to retry the microphone.');
        });
    }

    function startWebRTC() {
        webRTCFallbackReady = false;
        webRTCSession = true;
        openingResponsePending = true;
        if (isAppleMobileDevice()) {
            debugLog('Apple mobile detected; bypassing WebRTC and starting MediaRecorder fallback immediately');
            return activateWebRTCFallback(new Error('WebRTC bypassed on Apple mobile'));
        }
        const botProfile = window.growtype_chat[chatForm.attr('id')]['bot_profile'] || {};
        return startWebRTCLiveCall(webRTCState, {
            debugLog: debugLog,
            openingInstruction: botProfile.live_call_opening_instruction || '',
            onConnecting: function() {
                setVoiceExperienceState('connecting', 'Connecting securely…');
                hideActionBtns();
            },
            onConnected: function() {
                setVoiceChangeInProgress(false);
                setSessionStarted(true);
                sessionStartInProgress = false;
                isRecording = true;
                $('#growtypeChatVideoCallModal').addClass('is-recording is-webrtc');
                stopLoadingAnimation();
                hideActionBtns();
                _syncConnectedMuteState({
                    isMuted: function() { return isMuted; },
                    isTransportMuted: function() { return webRTCState.muted; },
                    setMuted: function(value) { isMuted = value; },
                    setConversationActive: setConversationActive,
                    setMutedControl: function(value) { voiceExperience.setMutedControl(value); },
                    renderConnectedState: function(muted) {
                        if (muted) {
                            setWebRTCVisualState('muted');
                            showInfoMessage('Muted');
                        } else {
                            setWebRTCVisualState('listening');
                            showInfoMessage('Listening… Speak naturally, even quietly.');
                        }
                    },
                });
            },
            onSpeechStarted: function() {
                if (openingResponsePending) {
                    debugLog('Opening WebRTC response interrupted by user; enabling normal captions');
                    openingResponsePending = false;
                    window.__aiResponseTranscript = '';
                }
                window.__userTranscript = '';
                setWebRTCVisualState('listening');
                showInfoMessage('Listening…');
            },
            onSpeechStopped: function() {
                window.__aiResponseTranscript = '';
                setWebRTCVisualState('thinking');
                showInfoMessage('Thinking…');
            },
            onResponseStarted: function() {
                window.__aiResponseTranscript = '';
                aiResponseStarted = false;
            },
            onUserTranscript: function(transcript) {
                window.__userTranscript = transcript;
                currentTranscription.val = transcript;
                showInfoMessage(`You: "${transcript}"`);
                _sendToWebSocket({
                    type: 'save_transcription',
                    session_token: sessionToken,
                    transcription: transcript,
                }, wsSendCtx);
            },
            onAssistantTranscriptDelta: function(delta) {
                window.__aiResponseTranscript = (window.__aiResponseTranscript || '') + delta;
                if (openingResponsePending) {
                    debugLog('Opening WebRTC response transcript kept audio-only', {
                        contentLength: delta.length,
                    });
                } else if (infoTextContainer) {
                    if (!aiResponseStarted) {
                        infoTextContainer.text('');
                        aiResponseStarted = true;
                    }
                    infoTextContainer.append(delta);
                }
            },
            onRemoteAudioStarted: function() {
                if (isMuted) {
                    isAudioPlaying = false;
                    setWebRTCVisualState('muted');
                    return;
                }
                isAudioPlaying = true;
                setWebRTCVisualState('speaking');
            },
            onRemoteAudioStopped: function() {
                isAudioPlaying = false;
                aiResponseStarted = false;
                if (!isMuted) {
                    setWebRTCVisualState('listening');
                    showInfoMessage('Listening… Speak naturally, even quietly.');
                }
            },
            onResponseCancelled: function() {
                window.__aiResponseTranscript = '';
                aiResponseStarted = false;
                if (!isMuted) {
                    setWebRTCVisualState('listening');
                    showInfoMessage('Listening…');
                }
            },
            onResponseCompleted: function(transcript, totalTokens) {
                if (transcript) {
                    window.__aiResponseTranscript = transcript;
                    _sendToWebSocket({
                        type: 'save_ai_response',
                        session_token: sessionToken,
                        message: transcript,
                    }, wsSendCtx);
                }
                if (openingResponsePending) {
                    debugLog('Opening WebRTC response completed as audio-only; skipping chat text rendering');
                    openingResponsePending = false;
                    window.__userTranscript = '';
                    window.__aiResponseTranscript = '';
                } else {
                    saveVideocallMessages(chatForm, sessionToken, debugLog);
                }
                currentTranscription.val = '';
                aiResponseStarted = false;
                if (totalTokens > 0) {
                    handleTokenUsage(totalTokens);
                    handleAwardXp();
                }
            },
            onProviderError: function(message) {
                setVoiceExperienceState('error');
                showError(message);
            },
            sendBrokerOffer: function(sdp) {
                _sendToWebSocket({
                    type: 'webrtc_offer',
                    session_token: sessionToken,
                    bot_profile: window.growtype_chat[chatForm.attr('id')]['bot_profile'],
                    voice: getSelectedVideocallVoice(),
                    domain: sessionDomain,
                    sdp: sdp,
                }, wsSendCtx);
            },
            onFallback: activateWebRTCFallback,
        });
    }

    function acceptWebRTCAnswer(answerSdp) {
        return _acceptWebRTCAnswer(webRTCState, answerSdp, {
            debugLog: debugLog,
            onFallback: activateWebRTCFallback,
        });
    }

    function handleWebRTCError(message) {
        // A broker/provider failure is not browser-specific. Avoid repeating the
        // same failed negotiation when the modal is reopened on this page.
        webRTCDisabledForPage = true;
        debugLog('WebRTC disabled for this page after broker failure; switching to classic transport', {
            message: message,
        });
        activateWebRTCFallback(new Error(message));
    }

    function maybeScheduleLegacyFollowUp() {
        debugLog('Legacy auto-resume checkpoint', {
            legacyResponseCompleted: legacyResponseCompleted,
            legacyAutoResumePending: legacyAutoResumePending,
            isAudioPlaying: isAudioPlaying,
            scheduledSources: playerState.scheduledSources.length,
            autoListenEnabled: autoRecordEnabled(),
            isModalOpen: isModalOpen,
            isMuted: isMuted,
            isRecording: isRecording,
            conversationStopped: conversationStopped,
            webRTCSession: webRTCSession,
            liveKitSession: liveKitSession,
            recorderState: audioRecorder ? audioRecorder.state : null,
        });
        if (!legacyResponseCompleted || isAudioPlaying || playerState.scheduledSources.length) {
            debugLog('Legacy auto-resume waiting for response completion and an empty audio queue');
            return;
        }
        legacyResponseCompleted = false;

        if (!legacyAutoResumePending || !autoRecordEnabled()) {
            debugLog('Legacy auto-resume not scheduled', {
                reason: !legacyAutoResumePending ? 'no transcript-finished utterance is pending' : 'Auto Listen is disabled',
            });
            return;
        }

        if (legacyAutoResumeTimeout) clearTimeout(legacyAutoResumeTimeout);
        debugLog('Legacy auto-resume timer scheduled', { delayMs: 300 });
        legacyAutoResumeTimeout = setTimeout(function() {
            legacyAutoResumeTimeout = null;

            const blockedBy = [];
            if (!legacyAutoResumePending) blockedBy.push('no-pending-utterance');
            if (webRTCSession) blockedBy.push('webrtc-session');
            if (liveKitSession) blockedBy.push('livekit-session');
            if (!isModalOpen) blockedBy.push('modal-closed');
            if (isMuted) blockedBy.push('muted');
            if (isRecording) blockedBy.push('already-recording');
            if (conversationStopped) blockedBy.push('conversation-stopped');
            if (isAudioPlaying) blockedBy.push('audio-playing');
            if (playerState.scheduledSources.length) blockedBy.push('audio-queue-not-empty');
            if (!autoRecordEnabled()) blockedBy.push('auto-listen-disabled');

            debugLog('Legacy auto-resume timer fired', {
                blockedBy: blockedBy,
                scheduledSources: playerState.scheduledSources.length,
                recorderState: audioRecorder ? audioRecorder.state : null,
            });

            if (blockedBy.length) {
                return;
            }

            legacyAutoResumePending = false;
            debugLog("🎤 Assistant finished; resuming MediaRecorder automatically");
            startRecording({ automaticResume: true });
        }, 300);
    }

    function cancelLegacyAutoResume() {
        const hadPendingResume = legacyAutoResumePending || !!legacyAutoResumeTimeout;
        legacyAutoResumePending = false;
        if (legacyAutoResumeTimeout) {
            clearTimeout(legacyAutoResumeTimeout);
            legacyAutoResumeTimeout = null;
        }
        if (hadPendingResume) debugLog('Legacy auto-resume state cancelled');
    }

    function pauseLegacyRecordingForAssistant() {
        if (liveKitSession || webRTCSession || !isRecording || !audioRecorder || audioRecorder.state !== 'recording') return;

        debugLog('Assistant audio started while MediaRecorder was listening; discarding the speaker-playback segment');
        discardCurrentRecording = true;
        legacyAutoResumePending = true;
        userSaidSomethingCounter = 0;
        _finishRecordingTurn(recordingCtx);
    }

    function ensureAudioLevelMonitoring() {
        if (analyser && dataArray) return Promise.resolve(true);
        if (audioLevelInitializationPromise) return audioLevelInitializationPromise;

        debugLog('MediaRecorder audio-level fallback initialization requested');
        audioLevelInitializationPromise = Promise.resolve(_initAudioLevel(audioLevelCtx))
            .then(function(initialized) {
                debugLog(initialized
                    ? '✅ MediaRecorder audio-level fallback ready'
                    : '⚠️ MediaRecorder audio-level fallback unavailable');
                return initialized;
            })
            .catch(function(error) {
                debugLog('MediaRecorder audio-level fallback initialization failed', {
                    name: error && error.name,
                    message: error && error.message,
                });
                return false;
            })
            .finally(function() {
                audioLevelInitializationPromise = null;
            });

        return audioLevelInitializationPromise;
    }

    const recordingCtx = {
        get userSaidSomethingCounter() { return userSaidSomethingCounter; }, set userSaidSomethingCounter(v) { userSaidSomethingCounter = v; },
        get isMuted() { return isMuted; }, set isMuted(v) { isMuted = v; },
        get isRecording() { return isRecording; }, set isRecording(v) { isRecording = v; },
        get canInterrupt() { return canInterrupt; },
        get isModalOpen() { return isModalOpen; },
        get sessionStarted() { return sessionStarted; }, set sessionStarted(v) { setSessionStarted(v); },
        get sessionStartInProgress() { return sessionStartInProgress; }, set sessionStartInProgress(v) { sessionStartInProgress = v; },
        setIsRecording: function(value) { isRecording = value; },
        setSessionStarted: function(value) { setSessionStarted(value); },
        setSessionStartInProgress: function(value) { sessionStartInProgress = value; },
        socket: socket,
        get sessionToken() { return sessionToken; },
        get sessionDomain() { return sessionDomain; },
        get chatId() { return chatForm.attr('id'); },
        getSelectedVoice: getSelectedVideocallVoice,
        sendToWs: function(data) { _sendToWebSocket(data, wsSendCtx); },
        onSessionStartRequested: function() { openingResponsePending = true; },
        supportsLiveSpeech: supportsBrowserSpeechTransport,
        get stopRecordingBtnText() { return stopRecordingBtnText; },
        get continueRecordingBtnText() { return continueRecordingBtnText; },
        stopAudio: function() { _stopAudio(playerState, null, debugLog); },
        stopLoadingAnimation: stopLoadingAnimation,
        debugLog: debugLog,
        get conversationStopped() { return conversationStopped; }, set conversationStopped(v) { conversationStopped = v; },
        abortAjax: abortAjaxRequest,
        get silenceTimerVal() { return silenceTimer; }, set silenceTimerVal(v) { silenceTimer = v; },
        get discardCurrentRecording() { return discardCurrentRecording; },
        set discardCurrentRecording(v) { discardCurrentRecording = Boolean(v); },
        hideInfoMessage: hideInfoMessage,
        finishUtterance: function() {
            debugLog("Last-resort MediaRecorder turn boundary reached; sending audio to provider", {
                previousAutoResumePending: legacyAutoResumePending,
                isRecording: isRecording,
                recorderState: audioRecorder ? audioRecorder.state : null,
                autoListenEnabled: autoRecordEnabled(),
            });
            legacyAutoResumePending = true;
            debugLog('Legacy auto-resume marked pending');
            setWebRTCVisualState('thinking');
            showInfoMessage('Thinking…');
            _finishRecordingTurn(recordingCtx);
        },
    };

    function startRecording(options = {}) {
        const automaticResume = Boolean(options.automaticResume);
        debugLog('startRecording wrapper entered', {
            automaticResume: automaticResume,
            liveKitSession: liveKitSession,
            webRTCSession: webRTCSession,
            webRTCFallbackReady: webRTCFallbackReady,
            isRecording: isRecording,
            recorderState: audioRecorder ? audioRecorder.state : null,
            sessionStarted: sessionStarted,
        });
        if (!automaticResume) {
            cancelLegacyAutoResume();
        }
        conversationStopped = false;
        setConversationActive(true);
        if (liveKitTransportEnabled() && !liveKitSession) {
            setVoiceExperienceState('connecting', 'Connecting securely…');
            showInfoMessage('Connecting securely…');
            return;
        }
        if (liveKitSession) {
            setLiveKitMuted(liveKitState, false).catch(handleLiveKitError);
            isMuted = false;
            isRecording = true;
            showInfoMessage('Listening… Speak naturally.');
            return;
        }
        if (webRTCSession) {
            setWebRTCMicrophoneMuted(webRTCState, false);
            isMuted = false;
            isRecording = true;
            showInfoMessage('Listening… Speak naturally, even quietly.');
            return;
        }
        _startRec(recordingCtx);
        if (isRecording && !isMuted) {
            setVoiceExperienceState('listening', automaticResume ? 'Your turn — I’m listening.' : 'Listening… Speak naturally.');
        }
    }

    function stopRecording(isMute) {
        if (!isMute) {
            cancelLegacyAutoResume();
            _cancelScheduledVoiceTransportRestart(voiceRestartState);
            setConversationActive(false);
        }
        if (liveKitSession) {
            if (isMute) {
                liveCallInactivity.pause();
                setLiveKitMuted(liveKitState, true).catch(handleLiveKitError);
                isMuted = true;
                showInfoMessage('Muted');
                return;
            }

            liveCallInactivity.pause();
            stopLiveKitCall(liveKitState);
            liveKitSession = false;
            if (socket.val && socket.val.readyState === WebSocket.OPEN) _closeWebSocket(socket.val);
            socket.val = null;
            setSessionStarted(false);
            sessionStartInProgress = false;
            isRecording = false;
            liveCallAccessToken = '';
            $('#growtypeChatVideoCallModal').removeClass('is-recording is-livekit');
            setVoiceExperienceState('');
            return;
        }
        if (webRTCSession) {
            if (isMute) {
                setWebRTCMicrophoneMuted(webRTCState, true);
                isMuted = true;
                showInfoMessage('Muted');
                return;
            }

            stopWebRTCLiveCall(webRTCState, { releaseMicrophone: false });
            if (socket.val && socket.val.readyState === WebSocket.OPEN) {
                _sendToWebSocket({ session_token: sessionToken, type: 'end_session' }, wsSendCtx);
                _closeWebSocket(socket.val);
            }
            socket.val = null;
            setSessionStarted(false);
            sessionStartInProgress = false;
            isRecording = false;
            liveCallAccessToken = '';
            $('#growtypeChatVideoCallModal').removeClass('is-recording is-webrtc');
            setWebRTCVisualState('');
            return;
        }
        _stopRec(recordingCtx, isMute);
        if (!isMute) liveCallAccessToken = '';
    }

    // Abort AJAX request
    function abortAjaxRequest() {
        if (ajaxRequest && ajaxRequest.readyState !== 4) {
            ajaxRequest.abort();
            debugLog("AJAX request aborted due to modal close.");
            ajaxRequest = null;
        }
    }

    function selectAndSaveMatchedVoice(humeVoice, cartesiaVoice, btnElement = null) {
        _selectMatchedVoice(humeVoice, cartesiaVoice, btnElement, resolveChatSettingOption, updateChatSettings);
    }

    function getSelectedVideocallVoice() {
        return $('#growtypeChatVideoCallModal .modal-videocall-voice-select').val() || '';
    }

    function changeVideocallVoice(select) {
        function voiceTransportContext(voice) {
            return {
                isLiveKitActive: function() {
                    return liveKitSession && (liveKitState.active || liveKitState.connecting);
                },
                interruptLiveKit: function() {
                    interruptLiveKitAssistant(liveKitState).catch(handleLiveKitError);
                },
                restartLiveKit: function() {
                    showInfoMessage('Changing voice…');
                    stopLiveKitCall(liveKitState, { preserveMuted: true });
                    liveKitSession = false;
                    setSessionStarted(false);
                    sessionStartInProgress = true;
                    if (socket.val && socket.val.readyState === WebSocket.OPEN) startLiveKit();
                    else startWebservice();
                },
                isWebRTCActive: function() {
                    return webRTCSession && !webRTCFallbackReady && (webRTCState.active || webRTCState.connecting);
                },
                interruptWebRTC: function() {
                    interruptWebRTCAssistant(webRTCState, { debugLog: debugLog });
                },
                restartWebRTC: function() {
                    showInfoMessage('Changing voice…');
                    stopWebRTCLiveCall(webRTCState, { releaseMicrophone: false, preserveMuted: true });
                    setSessionStarted(false);
                    sessionStartInProgress = true;
                    startWebRTC();
                },
                isClassicSessionActive: function() {
                    return sessionStarted && socket.val && socket.val.readyState === WebSocket.OPEN;
                },
                interruptClassic: function() {
                    _stopAudio(playerState, null, debugLog);
                },
                changeClassicVoice: function() {
                    _sendToWebSocket({
                        type: 'change_voice',
                        session_token: sessionToken,
                        voice: voice,
                    }, wsSendCtx);
                },
            };
        }

        return _changeVideocallVoice(select, {
            persistVoice: function(voice) {
                return $.ajax({
                    url: growtype_chat_ajax.url,
                    type: 'post',
                    data: {
                        action: 'growtype_chat_update_settings',
                        session: {
                            token: sessionToken,
                            settings: { growtype_chat_videocall_voice: voice },
                        },
                        nonce: growtype_chat_ajax.nonce,
                    },
                });
            },
            onVoiceChangeStarted: function(voice) {
                _cancelScheduledVoiceTransportRestart(voiceRestartState);
                setVoiceChangeInProgress(true);
                showInfoMessage('Changing voice…');
                _interruptVoiceTransport(voiceTransportContext(voice));
            },
            onVoiceChanged: function(voice) {
                _scheduleVoiceTransportRestart(voiceRestartState, function() {
                    const transport = _restartVoiceTransport(voiceTransportContext(voice));
                    if (transport === 'classic' || transport === 'none') {
                        setVoiceChangeInProgress(false);
                    }
                });
            },
            onVoiceChangeFailed: function(previousVoice) {
                _scheduleVoiceTransportRestart(voiceRestartState, function() {
                    const transport = _restartVoiceTransport(voiceTransportContext(previousVoice));
                    if (transport === 'classic' || transport === 'none') {
                        setVoiceChangeInProgress(false);
                    }
                }, 0);
            },
            keepDisabledAfterSave: function() { return voiceChangeInProgress; },
        });
    }

    function setVoiceChangeInProgress(value) {
        voiceChangeInProgress = Boolean(value);
        clearTimeout(voiceChangeUnlockTimeout);
        voiceChangeUnlockTimeout = null;

        const modal = $('#growtypeChatVideoCallModal');
        modal.find('.modal-videocall-voice-select, .modal-videocall-voice-arrow')
            .prop('disabled', voiceChangeInProgress)
            .attr('aria-busy', voiceChangeInProgress ? 'true' : 'false');

        if (voiceChangeInProgress) {
            voiceChangeUnlockTimeout = setTimeout(function() {
                setVoiceChangeInProgress(false);
            }, 15000);
        }
    }

    /**
     * Show or hide the match-voice block depending on whether the current
     * settings voice already matches one of the character's mapped voices.
     */
    function syncMatchVoiceVisibility(modal) {
        _syncMatchVoiceFn(modal);
    }

    function setupModalEvents(modal) {
        _setupModalEvents(modal, {
            get isModalOpen() { return isModalOpen; }, set isModalOpen(v) { isModalOpen = v; },
            get dotsInterval() { return dotsInterval; },
            get timeoutId() { return timeoutId; },
            get startRecordingBtnText() { return startRecordingBtnText; },
            get isMuted() { return isMuted; }, set isMuted(v) { isMuted = v; },
            get btnRecordingTriggered() { return btnInitRecordingWasTriggeredOnce; }, set btnRecordingTriggered(v) { btnInitRecordingWasTriggeredOnce = v; },
            get reconnectAttempts() { return reconnectAttempts; }, set reconnectAttempts(v) { reconnectAttempts = v; },
            get maxReconnectAttempts() { return maxReconnectAttempts; },
            stopAudio: function() { _stopAudio(playerState, null, debugLog); },
            stopLoadingAnimation: stopLoadingAnimation,
            stopRecording: stopRecording,
            hideActionBtns: hideActionBtns,
            abortAjax: abortAjaxRequest,
            closeSocket: function() { _closeWebSocket(socket.val); socket.val = null; },
            syncMatchVoice: function(m) { _syncMatchVoiceFn(m); },
            selectVoice: selectAndSaveMatchedVoice,
            changeVoice: changeVideocallVoice,
            muteRecording: muteRecording,
            unMuteRecording: unMuteRecording,
            initRecordingBtn: initRecordingBtn,
            resetVoiceChangeState: function() { setVoiceChangeInProgress(false); },
            releaseReservationIfUnstarted: releaseReservationIfUnstarted,
            showError: showError,
            debugLog: debugLog,
        });
    }

    function releaseReservationIfUnstarted() {
        if (callEverStarted || sessionStarted || liveKitState.active || webRTCState.active || !liveCallReservationId) {
            return Promise.resolve(false);
        }

        const reservationId = liveCallReservationId;
        liveCallReservationId = '';
        liveCallAccessToken = '';

        return $.ajax({
            url: growtype_chat_ajax.url,
            type: 'post',
            data: {
                action: growtype_chat_ajax.release_videocall_reservation_action,
                reservation_id: reservationId,
                session_token: sessionToken,
                nonce: growtype_chat_ajax.nonce,
            },
        }).then(function() {
            debugLog('Unused Live Call reservation released');
            return true;
        }).catch(function(error) {
            debugLog('Unused Live Call reservation release failed', { status: error && error.status });
            return false;
        });
    }

    function showError(message) {
        setVoiceExperienceState('error');
        _showError(message, {
            isModalOpen: isModalOpen,
            infoTextContainer: infoTextContainer,
            dotsState: { get interval() { return dotsInterval; }, set interval(v) { dotsInterval = v; } },
            showInfoMessage: showInfoMessage,
        });
    }

    function showSupportError() {
        setVoiceExperienceState('error');
        stopLoadingAnimation();
        _showSupportErrorMessage(
            infoTextContainer,
            window.growtype_chat_ajax && window.growtype_chat_ajax.support_email
                ? window.growtype_chat_ajax.support_email
                : ''
        );
    }

    // Entry-point context (shared between click + visibility handlers)
    const entryCtx = {
        handleClick: function(btn, options) {
            callEverStarted = false;
            _handleClick(btn, {
                get conversationStopped() { return conversationStopped; }, set conversationStopped(v) { conversationStopped = v; },
                get chatForm() { return chatForm; }, set chatForm(v) { chatForm = v; },
                get sessionToken() { return sessionToken; }, set sessionToken(v) { sessionToken = v; },
                debugLog: debugLog,
                showError: showError,
                setupModalEvents: setupModalEvents,
                syncMatchVoice: syncMatchVoiceVisibility,
                setVoiceExperienceState: setVoiceExperienceState,
                get infoTextContainer() { return infoTextContainer; }, set infoTextContainer(v) { infoTextContainer = v; },
                get isModalOpen() { return isModalOpen; }, set isModalOpen(v) { isModalOpen = v; },
                setupBackgroundVideo: setupBackgroundVideo,
                startLoadingAnimation: startLoadingAnimation,
                postToAjax: postToAjax,
                handleAjaxError: handleAjaxError,
                stopAudio: function() { _stopAudio(playerState, null, debugLog); },
                muteRecording: muteRecording,
            }, options);
        },
        handleVisibility: function() {
            diagnostics.log('document visibility changed', {
                hidden: document.hidden,
                audioContextState: audioContext ? audioContext.state : null,
            });
            if (!document.hidden && audioContext && audioContext.state === 'suspended') {
                audioContext.resume().then(function() {
                    diagnostics.log('audio context resumed after visibility change');
                }).catch(function(error) {
                    diagnostics.log('audio context resume failed after visibility change', {
                        name: error && error.name,
                        message: error && error.message,
                    });
                });
            }
            _handleVisibility({
                get isModalOpen() { return isModalOpen; },
                stopAudio: function() { _stopAudio(playerState, null, debugLog); },
                muteRecording: muteRecording,
            });
        },
    };

    registerEventListeners(entryCtx);

    function muteRecording() {
        return _muteVideocall(createMuteActionContext());
    }

    function unMuteRecording() {
        return _unmuteVideocall(createMuteActionContext());
    }

    function createMuteActionContext() {
        return {
            getTransport: function() {
                if (liveKitSession) return 'livekit';
                if (webRTCSession) return 'webrtc';
                return 'legacy';
            },
            setConversationActive: setConversationActive,
            setMuted: function(value) { isMuted = Boolean(value); },
            setAudioPlaying: function(value) { isAudioPlaying = Boolean(value); },
            stopAudio: function() { _stopAudio(playerState, null, debugLog); },
            setLiveKitMuted: function(value) {
                if (value) liveCallInactivity.pause();
                else liveCallInactivity.start();
                setLiveKitMuted(liveKitState, value).catch(handleLiveKitError);
            },
            setWebRTCMuted: function(value) {
                setWebRTCMicrophoneMuted(webRTCState, value, { debugLog: debugLog });
            },
            muteLegacy: function() {
                _mute({ get isMuted() { return isMuted; }, set isMuted(v) { isMuted = v; }, get startRecordingBtnText() { return startRecordingBtnText; }, stopRecording: stopRecording, hideActionBtns: hideActionBtns });
            },
            unmuteLegacy: function() {
                _unMute({ get isMuted() { return isMuted; }, set isMuted(v) { isMuted = v; }, get isRecording() { return isRecording; }, supportsLiveSpeech: supportsBrowserSpeechTransport, getSocketState: function() { return socket.val && socket.val.readyState === WebSocket.OPEN; }, startWebservice: startWebservice, startRecording: startRecording, showActionBtns: showActionBtns });
            },
            renderMutedState: function(transport) {
                voiceExperience.setMutedControl(true);
                $('#growtypeChatVideoCallModal .modal-videocall-actions-mute')
                    .closest('.modal-videocall-actions-action')
                    .addClass('anim-shake');
                if (transport === 'webrtc') setWebRTCVisualState('muted');
                else setVoiceExperienceState('muted', transport === 'legacy' ? 'Microphone muted' : undefined);
                if (transport !== 'legacy') showInfoMessage('Muted');
            },
            renderUnmutedState: function(transport) {
                voiceExperience.setMutedControl(false);
                $('#growtypeChatVideoCallModal .modal-videocall-actions-mute')
                    .closest('.modal-videocall-actions-action')
                    .removeClass('anim-shake');
                if (transport === 'livekit') {
                    setVoiceExperienceState('listening');
                    showInfoMessage('Listening… Speak naturally.');
                } else if (transport === 'webrtc') {
                    setWebRTCVisualState('listening');
                    showInfoMessage('Listening… Speak naturally, even quietly.');
                } else if (!isRecording && sessionStarted && !conversationStopped) {
                    startRecording({ automaticResume: true });
                } else {
                    setVoiceExperienceState(isRecording ? 'listening' : 'idle', isRecording ? 'Your turn — I’m listening.' : 'Tap Start to continue.');
                }
            },
        };
    }

    async function startWebservice() {
        if (!liveCallAccessToken) {
            postToAjax();
            return;
        }
        await _startWebservice({
            get socket() { return { get value() { return socket.val; }, set value(v) { socket.val = v; } }; },
        get chatId() { return chatForm.attr('id'); },
            get sessionToken() { return sessionToken; },
            debugLog: debugLog,
            showError: showError,
            stopLoadingAnimation: stopLoadingAnimation,
            showActionBtns: showActionBtns,
            setupRecording: setupRecording,
            supportsLiveKit: liveKitTransportEnabled,
            startLiveKit: startLiveKit,
            supportsWebRTC: webRTCTransportEnabled,
            startWebRTC: startWebRTC,
            acceptWebRTCAnswer: acceptWebRTCAnswer,
            handleWebRTCError: handleWebRTCError,
            supportsLiveSpeech: supportsBrowserSpeechTransport,
            startRecording: startRecording,
            stopAudio: function() { _stopAudio(playerState, null, debugLog); },
            stopRecording: stopRecording,
            reconnectAttempts: { get val() { return reconnectAttempts; }, set val(v) { reconnectAttempts = v; } },
            get maxReconnectAttempts() { return maxReconnectAttempts; },
            get isModalOpen() { return isModalOpen; },
            isIndependentTransportActive: function() { return liveKitState.active; },
            releaseReservation: releaseReservationIfUnstarted,
            handleMessage: handleWebSocketMessage,
            onSocketEvent: function(type, metadata) {
                diagnostics.log(`socket ${type}`, metadata);
                if (!isModalOpen) return;
                if (metadata && metadata.independentTransportActive) return;
                if (type === 'open') setVoiceExperienceState('connecting', 'Connected. Preparing your call…');
                if (type === 'close' && !conversationStopped) {
                    if (metadata && metadata.willReconnect) {
                        const attempt = metadata.nextAttempt || 1;
                        setVoiceExperienceState('reconnecting', navigator.onLine ? `Connection interrupted. Rejoining (${attempt}/${maxReconnectAttempts})…` : 'You are offline. Waiting for connection…');
                    } else if (metadata && metadata.code !== 1000) {
                        setVoiceExperienceState('error', 'Call disconnected. Tap Continue Conversation to reconnect.');
                    }
                }
                if (type === 'error') setVoiceExperienceState('reconnecting', 'Connection issue. Retrying…');
            },
        });
    }

    function initRecordingBtn() {
        _initRecBtn({
            get startRecordingBtnText() { return startRecordingBtnText; },
            get btnRecordTriggered() { return btnRecordTriggered; }, set btnRecordTriggered(v) { btnRecordTriggered = v; },
            get isMuted() { return isMuted; },
            get isRecording() { return isRecording; },
            get btnRecordingTriggered() { return btnInitRecordingWasTriggeredOnce; }, set btnRecordingTriggered(v) { btnInitRecordingWasTriggeredOnce = v; },
            stopRecording: stopRecording,
            startWebservice: startWebservice,
            startRecording: startRecording,
            hasAccessToken: function() { return !!liveCallAccessToken; },
            initMic: function() {
                if (liveKitTransportEnabled()) return;
                _initMic(debugLog).then(function() {
                    ensureAudioLevelMonitoring();
                });
            },
            getSocketState: function() { return socket.val && socket.val.readyState === WebSocket.OPEN; },
            debugLog: debugLog,
        });
    }

    function showActionBtns() {
        _showInactiveConversationControl({
            setConversationActive: setConversationActive,
            showControl: _showBtns,
        });
    }

    function hideActionBtns() { _hideBtns(); }

    function setupRecording() {
        debugLog('Recording pipeline setup requested');
        return setupAudioRecording();
    }

    async function setupAudioRecording() {
        debugLog("Passing recording callbacks into audio pipeline", {
            finishUtteranceAvailable: typeof recordingCtx.finishUtterance === 'function',
        });
        return _setupAudioRecording({
            supportsMediaDevices: supportsMediaDevices,
            debugLog: debugLog,
            currentTranscription: currentTranscription,
            socket: socket,
            get sessionStarted() { return sessionStarted; },
            get sessionToken() { return sessionToken; },
            sendToWs: function(data) { _sendToWebSocket(data, wsSendCtx); },
            audioRecorder: { get val() { return audioRecorder; }, set val(v) { audioRecorder = v; } },
            monitorSilenceFn: function() { _monitorSilence(silenceCtx); },
            monitorSpeechFn: function() { _monitorSpeech(silenceCtx); },
            get userSaidSomethingCounter() { return userSaidSomethingCounter; },
            set userSaidSomethingCounter(v) { userSaidSomethingCounter = v; },
            get assistantAudioActive() { return assistantAudioActive(); },
            get discardCurrentRecording() { return discardCurrentRecording; },
            set discardCurrentRecording(v) { discardCurrentRecording = Boolean(v); },
            finishUtterance: function() {
                debugLog("Audio pipeline requested utterance completion");
                recordingCtx.finishUtterance();
                debugLog("Audio pipeline utterance completion callback returned");
            },
            get chatId() { return chatForm.attr('id'); },
            audioBufferToWav: audioBufferToWav,
            blobToBase64: blobToBase64,
            onRecordingError: function(error) {
                diagnostics.log('recording pipeline failed', {
                    name: error && error.name,
                    message: error && error.message,
                });
                showError('Could not process microphone audio. Please try again.');
            },
        });
    }

    function handleWebSocketMessage(event) {
        _handleWsMessage(event, {
            debugLog: debugLog,
            sessionState: { get started() { return sessionStarted; }, set started(v) { setSessionStarted(v); }, get startInProgress() { return sessionStartInProgress; }, set startInProgress(v) { sessionStartInProgress = v; } },
            uiState: {
                get aiResponseStarted() { return aiResponseStarted; },
                set aiResponseStarted(v) { aiResponseStarted = v; },
                get openingResponsePending() { return openingResponsePending; },
                set openingResponsePending(v) { openingResponsePending = Boolean(v); },
            },
            infoTextContainer: infoTextContainer,
            showError: showError,
            showSupportError: showSupportError,
            connectLiveKitSession: connectLiveKit,
            handleLiveKitError: handleLiveKitError,
            onLiveCallLimitReached: function(message) {
                conversationStopped = true;
                stopRecording(false);
                showError(message);
                setVoiceExperienceState('error', message);
            },
            acceptWebRTCAnswer: acceptWebRTCAnswer,
            handleWebRTCError: handleWebRTCError,
            onUserSpeechStarted: function() {
                setVoiceExperienceState('listening');
            },
            onUserSpeechStopped: function() {
                setVoiceExperienceState('thinking', 'Got it — thinking…');
            },
            onAssistantResponseCompleted: function() {
                debugLog('Legacy response completion callback entered', {
                    previousResponseCompleted: legacyResponseCompleted,
                    legacyAutoResumePending: legacyAutoResumePending,
                    isAudioPlaying: isAudioPlaying,
                    scheduledSources: playerState.scheduledSources.length,
                    recorderState: audioRecorder ? audioRecorder.state : null,
                });
                legacyResponseCompleted = true;
                maybeScheduleLegacyFollowUp();
            },
            onFollowUpError: function(message) {
                debugLog('Silence follow-up was not started', { message: message });
            },
            onMessageReceived: function(data, metadata) { diagnostics.onMessageReceived(data, metadata); },
            saveMessages: function() { saveVideocallMessages(chatForm, sessionToken, debugLog); },
            handleTokenUsage: handleTokenUsage,
            handleAwardXp: handleAwardXp,
            stopAudio: function() { _stopAudio(playerState, null, debugLog); },
            handleAudio: function(content) {
                if (isMuted) {
                    debugLog('Assistant audio ignored while call is muted');
                    return Promise.resolve();
                }
                legacyResponseCompleted = false;
                pauseLegacyRecordingForAssistant();
                setVoiceExperienceState('speaking');
                debugLog('Provider VAD decides interruptions from the continuously streamed microphone');
                return _handleAudioResponse(content, {
                    audioCtx: audioCtx,
                    nextScheduledTime: nextScheduledTime,
                    debugLog: debugLog,
                    schedulePlayback: function(buf, t) {
                        _playBufferScheduled(buf, t, playerState, debugLog, {
                            onQueueEmpty: function() {
                                assistantAudioGuardUntil = Date.now() + 600;
                                debugLog('Assistant playback echo guard started', { durationMs: 600 });
                                maybeScheduleLegacyFollowUp();
                            },
                        });
                    },
                });
            },
            setCurrentTranscription: function(v) { currentTranscription.val = v; },
        });
    }

    // Play assistant audio; provider VAD is the only interruption authority.
    let audioCtx = new AudioContextClass();
    audioContext = audioCtx;
    audioCtx.addEventListener('statechange', function() {
        diagnostics.log('playback audio context state changed', { audioContextState: audioCtx.state });
    });
    let playQueue = Promise.resolve();
    let nextScheduledTime = { val: 0 }; // Track when next chunk should start
    let pitchFactor = 1;

    // Shared player state passed to audio player service
    const playerState = {
        get audioCtx() { return audioCtx; },
        set audioCtx(v) { audioCtx = v; },
        currentAudio: null,
        get currentBufferSource() { return currentBufferSource; },
        set currentBufferSource(v) { currentBufferSource = v; },
        get scheduledSources() { return scheduledSources; },
        set scheduledSources(v) { scheduledSources = v; },
        get isAudioPlaying() { return isAudioPlaying; },
        set isAudioPlaying(v) {
            isAudioPlaying = v;
            if (!webRTCSession) {
                const isActiveTurn = legacyAutoResumePending || (btnInitRecordingWasTriggeredOnce && !conversationStopped);
                const providerStreamIsListening = !audioRecorder && isRecording && legacyResponseCompleted && !isMuted && !conversationStopped;
                setVoiceExperienceState(v ? 'speaking' : (providerStreamIsListening ? 'listening' : (isActiveTurn ? 'thinking' : 'idle')));
            }
        },
        get pitchFactor() { return pitchFactor; },
        set pitchFactor(v) { pitchFactor = v; },
        get playQueue() { return playQueue; },
        set playQueue(v) { playQueue = v; },
        get nextScheduledTime() { return nextScheduledTime; },
        set nextScheduledTime(v) { nextScheduledTime = v; },
    };

    function handleTokenUsage(tokens) {
        return _handleTokenUsage(tokens, {
            updateCredits: updateCredits,
            handleAjaxError: handleAjaxError,
            useCreditsResponseEvent: useCreditsResponseEvent,
        });
    }

    function handleAwardXp() {
        _handleAwardXp(sessionToken, debugLog, handleAjaxError);
    }

    function playBuffer(buffer) {
        return _playBuffer(buffer, playerState, {
            onPlayEnd: function() { if (isModalOpen && !isMuted) { if (autoRecordEnabled()) { debugLog("🎤 Auto-rec enabled, restarting..."); setTimeout(() => startRecording(), 300); } } },
            endDebounceMs: AI_FINISHED_SPEAKING_DEBOUNCE_DELAY,
        }, debugLog);
    }

    function postToAjax(options = {}) {
        _postToAjax({
            get timeoutId() { return timeoutId; }, set timeoutId(v) { timeoutId = v; },
            get ajaxRequest() { return ajaxRequest; }, set ajaxRequest(v) { ajaxRequest = v; },
            get sessionToken() { return sessionToken; },
            get sessionDomain() { return sessionDomain; }, set sessionDomain(v) { sessionDomain = v; },
            get liveCallAccessToken() { return liveCallAccessToken; }, set liveCallAccessToken(v) { liveCallAccessToken = v; },
            get liveCallReservationId() { return liveCallReservationId; }, set liveCallReservationId(v) { liveCallReservationId = v; },
            get liveAvatarEnabled() {
                return $('#growtypeChatVideoCallModal input[name="growtype_chat_live_avatar_enabled"]').is(':checked');
            },
            debugLog: debugLog,
            initAudioLevel: function() { return ensureAudioLevelMonitoring(); },
            audioLevelCtx: audioLevelCtx,
            startWebservice: startWebservice,
            handleAjaxError: handleAjaxError,
        }, options);
    }

    // Return public interface
    return {
        cleanup: function () {
            debugLog("Videocall cleanup started");
            liveCallInactivity.pause();
            stopRecording();
            clearInterval(dotsInterval);
            clearTimeout(timeoutId);
            if (microphoneStream) { microphoneStream.getTracks().forEach(t => t.stop()); microphoneStream = null; }
            releaseVideocallMicrophoneStream();
            removeDebugLifecycleListeners();
            videocallDebug.cleanup();
            diagnostics.reset('videocall cleanup');
            window.removeEventListener('online', handleBrowserOnline);
            window.removeEventListener('offline', handleBrowserOffline);
            if (audioContext && audioContext.state !== 'closed') audioContext.close();
            $('.g-chat-btn-videocall').off('click');
            $('#growtypeChatVideoCallModal .modal-videocall-actions-hangup').off('click.videocall');
            $('#growtypeChatVideoCallModal .modal-videocall-actions-mute').off('click.videocall');
            stopVideocallCamera($('#growtypeChatVideoCallModal'));
            $('#growtypeChatVideoCallModal .modal-videocall-actions-camera').off('click.videocallCamera');
            $('#growtypeChatVideoCallModal').off('show.bs.modal.videocallCamera');
            $('#growtypeChatVideoCallModal').off('hide.bs.modal.videocall');
        },
        startRecording: startRecording,
        stopRecording: stopRecording,
        getCurrentAudioLevel: function() { return _getAudioLevel(audioLevelCtx); },
        selectAndSaveMatchedVoice: selectAndSaveMatchedVoice
    };
}

export { videocall };
